import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  pending?: boolean;
  /** Copy-link flow uses draft→prospect + clipboard wording. */
  variant?: "send" | "copy_link";
};

export default function ProposalDraftPromotionDialog({
  open,
  onOpenChange,
  onConfirm,
  pending = false,
  variant = "send",
}: Props) {
  const isCopy = variant === "copy_link";
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{isCopy ? "Copy customer proposal link?" : "Promote to Prospect?"}</AlertDialogTitle>
          <AlertDialogDescription>
            {isCopy
              ? "This will move the proposal from DRAFT to PROSPECT and generate the customer proposal link. Continue?"
              : "To send the proposal to the customer, this proposal must move from Draft to Prospect. Should we promote this proposal to Prospect?"}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={pending}>Cancel</AlertDialogCancel>
          <AlertDialogAction disabled={pending} onClick={onConfirm}>
            {pending ? "Working…" : isCopy ? "Continue" : "Promote to Prospect and Continue"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
